import { FC, useState } from 'react';
import { useCustomUrl, useUpdateCustomUrl } from '@frx/frx-react-context';

import { Box } from '@chakra-ui/react';
import { GetCustomUrlResponse } from '@frx/frx-services';
import { CustomUrlJumpCard } from './CustomUrlJumpCard';
import { useEventId } from '../../../../hooks';
import { CustomUrlModal, Loader } from '../../../../components';

export const CustomizeUrl: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [page, setPage] = useState('create');
  const [errorMessage, setErrorMessage] = useState('');
  const FR_ID = useEventId();
  const { data, isInitialLoading } = useCustomUrl({ fr_id: FR_ID });
  const {
    mutate: update,
    isLoading: isSavingUrl,
    isError,
  } = useUpdateCustomUrl();

  const onSave = (url: string) => {
    update(
      { fr_id: FR_ID, text: url },
      {
        onSuccess: () => {
          setPage('confirm');
        },
        onError(err) {
          if (err.code === 2613) {
            setErrorMessage(
              'This custom URL already exists. Please choose another URL.'
            );
          } else {
            setErrorMessage('Sorry, we are unable to save the URL.');
          }
        },
      }
    );
  };

  if (isInitialLoading) return <Loader />;

  return (
    <Box
      bg="#135CB00D"
      borderRadius="8px"
      px={[5, 5, 7]}
      py={5}
      w="full"
      mb={6}
    >
      <CustomUrlJumpCard
        onEdit={() => {
          setIsOpen(true);
        }}
      />
      <CustomUrlModal
        headingLabel="Create your custom fundraiser URL"
        data={data as GetCustomUrlResponse}
        pageName={page}
        isSaving={isSavingUrl}
        onSave={(url: string) => {
          onSave(url);
        }}
        onStepClose={() => {
          setErrorMessage('');
          setPage('create');
          setIsOpen(false);
        }}
        isOpen={isOpen}
        isError={isError}
        errorMessage={errorMessage}
      />
    </Box>
  );
};
